import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { StatusBadge } from "@/components/StatusBadge";
import { ArrowUpRight, FileSignature } from "lucide-react";
import { formatCurrency, formatDateTime } from "@/lib/api";
import SignatureModal from "@/components/SignatureModal";
import AnticipationTimeline from "@/components/AnticipationTimeline";

export default function EmployeeAnticipations({ anticipations, onRefresh }) {
  const [signModal, setSignModal] = useState(null);

  return (
    <div className="py-6 space-y-4 stagger-children" data-testid="employee-anticipations">
      <h2 className="text-lg font-semibold animate-fade-in">Minhas Antecipações</h2>
      {anticipations.length === 0 ? (
        <div className="text-center py-12 animate-fade-in" data-testid="employee-anticipations-empty">
          <ArrowUpRight className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Nenhuma antecipação realizada</p>
        </div>
      ) : (
        anticipations.map((a) => (
          <Card key={a.id} data-testid={`anticipation-item-${a.id}`}
            className="border-white/5 card-interactive animate-fade-in">
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="text-xs text-muted-foreground">{formatDateTime(a.created_at)}</p>
                  <p className="text-sm font-medium mt-0.5">{a.titulo_count} título{a.titulo_count > 1 ? "s" : ""}</p>
                </div>
                <StatusBadge status={a.status} showNext={true} />
              </div>

              {a.awaiting_signature && a.signer_token && (
                <div className="mb-3 p-3 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <FileSignature className="w-4 h-4 text-blue-400" />
                    <span className="text-sm text-blue-400 font-medium">Contrato aguardando sua assinatura</span>
                  </div>
                  <Button size="sm" data-testid={`sign-btn-${a.id}`}
                    onClick={() => setSignModal(a)}
                    className="bg-blue-600 hover:bg-blue-700 text-white text-xs">
                    Assinar Agora
                  </Button>
                </div>
              )}

              <Separator className="bg-white/5 my-3" />
              <AnticipationTimeline anticipation={a} />
              <Separator className="bg-white/5 my-3" />
              <div className="flex justify-between text-sm">
                <div>
                  <p className="text-xs text-muted-foreground mb-0.5">Bruto</p>
                  <p className="font-medium">{formatCurrency(a.total_bruto)}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground mb-0.5">Líquido</p>
                  <p className="font-semibold text-emerald-400">{formatCurrency(a.total_liquido)}</p>
                </div>
              </div>
              <p className="text-[11px] text-muted-foreground mt-2">ID: {a.external_id}</p>
            </CardContent>
          </Card>
        ))
      )}

      {signModal && (
        <SignatureModal
          anticipationId={signModal.id}
          signerToken={signModal.signer_token}
          open={!!signModal}
          onOpenChange={(v) => { if (!v) setSignModal(null); }}
          onSigned={() => { setSignModal(null); onRefresh?.(); }}
        />
      )}
    </div>
  );
}
